<div class="row row--primary">
  <div class="col-12 pl-0 pr-0">
    <web-components-user-notes target="order-create" [dismissibleNotes]="true" />
  </div>
</div>
@if (!hasTradingSession) {
  <div class="row row--primary tile d-block">
    <web-components-trading-session (authorizationState)="setTradingSessionState($event)" />
  </div>
}

<div [class.opacity]="!hasTradingSession">
  <div class="row row--primary tile d-block opacity-container" [class.active]="setupComplete" data-zid="order-container">
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="submit()">
        <trade-create-header
          [direction]="directionFormControl.value"
          [marketPlace]="(tradeService.asset$ | async)?.marketName"
          [quoteTime]="(tradeService.quote$ | async)?.time"
        />
        <trade-create-asset
          [asset]="tradeService.asset$ | async"
          [isDisabled]="!hasTradingSession"
          [assetNotFound]="assetNotFound"
          (selectAsset)="assetSelected($event)"
          (resetAsset)="reset()"
        />
        <trade-create-hint
          [asset]="tradeService.asset$ | async"
          [direction]="directionFormControl.value"
          [errors]="form.errors"
          (experienceCheckCanceled)="reset()"
          (allowedToProceedOrderChange)="form.updateValueAndValidity()"
        />
        <trade-create-quote
          [asset]="tradeService.asset$ | async"
          [quote]="hasTradingSession ? (tradeService.quote$ | async) : null"
          [direction]="directionFormControl.value"
        />
        <trade-create-quantity
          [quote]="tradeService.quote$ | async"
          [asset]="tradeService.asset$ | async"
          [form]="quantityForm"
          [execType]="execTypeFormControl.value"
          [direction]="directionFormControl.value"
          [positionInSelectedAsset]="positionInSelectedAsset"
          [mode]="mode"
          (changeMode)="changeMode($event)"
        />
        <trade-create-options
          [quote]="tradeService.quote$ | async"
          [asset]="tradeService.asset$ | async"
          [type]="execTypeFormControl.value"
          [direction]="directionFormControl.value"
          [hasFraction]="quantityForm.value | hasFraction"
          [form]="optionsForm"
          [mode]="mode"
          (changeExecType)="changeExecType($event)"
          (changeMode)="changeMode($event)"
        />
        <trade-create-volume
          [form]="form"
          [orderVolume]="tradeService.orderVolume$ | async"
          [buyingPower]="tradeService.buyingPower$ | async"
          [buyingPowerDetails]="tradeService.buyingPowerDetails$ | async"
        />
        <div class="mt-1 mb-1">
          <web-components-user-messages [showLatestOnly]="true" />
        </div>
        <div class="mb-3">
          <web-design-system-button
            type="primary"
            size="large"
            [fullwidth]="true"
            [disabled]="form.invalid || !hasTradingSession || (shouldConfirmMiCARContracts$ | async)"
            [isSubmit]="true"
            data-zid="check-order"
          >
            {{ 'trade.create.button' | transloco | uppercase }}
          </web-design-system-button>
          <trade-donau-capital-hint />
        </div>
      </form>
    }
  </div>
</div>
<div class="session-tooltip" [style.left]="tooltip.left" [style.top]="tooltip.top">
  {{ 'trade.create.session-tooltip' | transloco }}
  <div class="arrow-down"></div>
</div>
